export default __webpack_public_path__ + "static/media/404_meme.84b8cc54.jpeg";